import React from 'react'
import styled from 'styled-components'

const LabelOnlyRadioButton = styled.label`
  display: block;
  padding: 15px;
  cursor: pointer;
  background: #fff;
  box-shadow: 0px 4px 15px 0px rgba(0, 0, 0, 0.15);
  border: 2px solid ${({ checked }) => (checked ? '#000' : '#ffffff')};
  border-radius: 5px;
  min-width: 120px;
`
const LabelOnlyRadioInput = styled.input`
  position:fixed;
  top: -1000px;

`

const RadioButtonsOnlyLabel = ({
  name,
  label,
  value,
  checked,
  onChange,
  onBlur,
}) => (
  <LabelOnlyRadioButton checked={checked}>
    {label}
    <LabelOnlyRadioInput
      type="radio"
      name={name}
      value={value}
      checked={checked}
      onChange={onChange}
      onBlur={onBlur}
    />
  </LabelOnlyRadioButton>
)

export default RadioButtonsOnlyLabel
